export const MOBILE_LAYOUT_MEDIA_QUERY = '(width < 1024px)';
export const MOBILE_INPUT_MEDIA_QUERY = '(width < 768px)';
export const MOBILE_GUIDE_QUERY = '(width < 640px)';
